import { RootState } from '../store';
import { IM10History } from './m10Types';

export const isPayoutSuccess = (state: RootState) => state.m10.isSuccess;
export const m10History = (state: RootState) => state.m10.history;
export const m10ExchangeRate = (state: RootState) => state.m10.rate;
export const m10FetchingState = (state: RootState) => state.m10.isFetching;
